module.exports = __webpack_public_path__ + "static/media/icon_chevrone.7fde1131.svg";